export default __webpack_public_path__ + "static/JJ_Logo_White-ce88b6397387c48691b6c20b7ca408b5.svg";